import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import Appbar from "../../Component/NavPannel/Appbar";
import ManagerManagementLayout from "../../Component/Layouts/ManagerManagementLayout";

const mdTheme = createTheme();

function ManagerManagement() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="User Management" />
        <ManagerManagementLayout />
      </Box>
    </ThemeProvider>
  );
}

export default function UserManagerManagement() {
  return <ManagerManagement />;
}
